import { useIntl } from 'react-intl';
import React, { useEffect } from 'react';
import moment from 'moment';
import { useFormikContext } from 'formik';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  FormControlLabel,
  Grid,
  Input,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import arLocale from 'date-fns/locale/ar';
import { initialValues } from 'components/ModalPAC';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import { updatePACObject } from '../../../store/pac/actions';
import {
  ErrorTitle,
  useStyles,
  PrimaryTitleCard,
  StyledListItemText,
} from '../DeclareFolderProcess/styles';

const ComplementInputs = () => {
  const intl = useIntl();
  const lang = useSelector(getLocaleSelector);
  const { values } = useFormikContext<any>();
  const phone = useSelector((state: RootStateOrAny) =>
    state.getIn(['user', 'phone']),
  );
  const email = useSelector((state: RootStateOrAny) =>
    state.getIn(['user', 'email']),
  );
  const classes = useStyles();
  const dispatch = useDispatch();

  /* istanbul ignore next */
  useEffect(() => {
    dispatch(
      updatePACObject({
        Gsm: phone,
        Email: email,
      }),
    );
  }, [dispatch, email, phone]);

  const { setFieldValue, errors, touched } = useFormikContext<any>();

  return (
    <MuiPickersUtilsProvider
      utils={DateFnsUtils}
      locale={lang === LANGUAGES.AR ? arLocale : frLocale}
    >
      <Grid container spacing={2} style={{ maxWidth: 550 }}>
        <Grid item xs={12} lg={12} md={12}>
          <PrimaryTitleCard style={{ marginBottom: 10 }} fontSize="14px">
            {intl.formatMessage({
              id: 'Home_text_Health_declarer_une_personne_step2_title',
            })}
          </PrimaryTitleCard>
        </Grid>
        <Grid item xs={6} lg={6} md={6}>
          <Input
            placeholder={intl.formatMessage({
              id: 'signup_personal_info.last_name',
            })}
            className={classes.inputTextStyle2}
            disableUnderline={true}
            startAdornment={<></>}
            value={values.nom}
            onChange={
              /* istanbul ignore next */
              (event) => {
                if (
                  event.target.value !== '' &&
                  /^[a-zA-Z- ]+$/.test(event.target.value)
                ) {
                  setFieldValue('nom', event.target.value);
                  dispatch(
                    updatePACObject({
                      Nom: event.target.value,
                    }),
                  );
                } else if (event.target.value === '') {
                  setFieldValue('nom', '');
                  dispatch(
                    updatePACObject({
                      Nom: '',
                    }),
                  );
                }
              }
            }
          />
          {values.nom !== initialValues.nom && (
            <ErrorTitle>
              {touched['nom'] && errors['nom'] && errors['nom']}
            </ErrorTitle>
          )}
        </Grid>
        <Grid item xs={6} lg={6} md={6}>
          <Input
            placeholder={intl.formatMessage({
              id: 'signup_personal_info.first_name',
            })}
            className={classes.inputTextStyle2}
            disableUnderline={true}
            startAdornment={<></>}
            value={values.prenom}
            onChange={
              /* istanbul ignore next */
              (event) => {
                if (
                  event.target.value !== '' &&
                  /^[a-zA-Z- ]+$/.test(event.target.value)
                ) {
                  setFieldValue('prenom', event.target.value);
                  dispatch(
                    updatePACObject({
                      Prenom: event.target.value,
                    }),
                  );
                } else if (event.target.value === '') {
                  setFieldValue('prenom', '');
                  dispatch(
                    updatePACObject({
                      Prenom: '',
                    }),
                  );
                }
              }
            }
          />
          {values.prenom !== initialValues.prenom && (
            <ErrorTitle>
              {touched['prenom'] && errors['prenom'] && errors['prenom']}
            </ErrorTitle>
          )}
        </Grid>
        <Grid item xs={12} lg={12} md={12}>
          <PrimaryTitleCard fontSize="14px">
            {intl.formatMessage({
              id:
                'Home_text_Health_declarer_une_personne_step2_click_calendar_title',
            })}
          </PrimaryTitleCard>
        </Grid>
        <Grid item xs={12} lg={12} md={12}>
          <KeyboardDatePicker
            variant="dialog"
            inputVariant="outlined"
            className={classes.inputDateStyle}
            format="dd/MM/yyyy"
            placeholder={intl.formatMessage({
              id: 'signup_personal_info.birthday',
            })}
            value={values.dateNaissance}
            onChange={
              /* istanbul ignore next */ (e) => {
                setFieldValue('dateNaissance', e);
                dispatch(
                  updatePACObject({
                    DateNaissanceFormatted: moment(e).format('DD/MM/YYYY'),
                  }),
                );
              }
            }
            name="dateNaissance"
            cancelLabel={intl.formatMessage({ id: 'addContract.cancel' })}
            okLabel={intl.formatMessage({
              id: 'dmo.info.consultation.date.ok',
            })}
            invalidDateMessage={''}
          />
          {values.dateNaissance !== null && (
            <ErrorTitle>
              {errors['dateNaissance'] && errors['dateNaissance']}
            </ErrorTitle>
          )}
        </Grid>

        <Grid item xs={2} lg={2} md={2} style={{ marginTop: 10 }}>
          <StyledListItemText
            primary={intl.formatMessage({
              id: 'Home_text_Health_declarer_une_personne_sexe',
            })}
          />
        </Grid>
        <Grid item xs={10} lg={10} md={10}>
          <RadioGroup row>
            <Grid item xs={5} lg={5} md={5} className={classes.radioGenre}>
              <FormControlLabel
                style={{ fontWeight: 200 }}
                name="masculin"
                value="M"
                checked={'M' === values.genre}
                control={<Radio />}
                label={intl.formatMessage({
                  id: 'Home_text_Health_declarer_une_personne_male',
                })}
                onChange={
                  /* istanbul ignore next */
                  (event) => {
                    setFieldValue(
                      'genre',
                      (event.target as HTMLTextAreaElement).value,
                    );
                    dispatch(
                      updatePACObject({
                        Genre: (event.target as HTMLTextAreaElement).value,
                      }),
                    );
                  }
                }
              />
            </Grid>

            <Grid item xs={5} lg={5} md={5} className={classes.radioGenre}>
              <FormControlLabel
                value="F"
                checked={'F' === values.genre}
                name="féminine"
                control={<Radio />}
                label={intl.formatMessage({
                  id: 'Home_text_Health_declarer_une_personne_female',
                })}
                onChange={
                  /* istanbul ignore next */
                  (event) => {
                    setFieldValue(
                      'genre',
                      (event.target as HTMLTextAreaElement).value,
                    );
                    dispatch(
                      updatePACObject({
                        Genre: (event.target as HTMLTextAreaElement).value,
                      }),
                    );
                  }
                }
              />
            </Grid>
          </RadioGroup>
          {values.genre !== initialValues.genre && (
            <ErrorTitle>
              {touched['genre'] && errors['genre'] && errors['genre']}
            </ErrorTitle>
          )}
        </Grid>
        <Grid item xs={6} lg={6} md={6}>
          <Input
            placeholder={intl.formatMessage({
              id: 'agent.phone',
            })}
            value={phone}
            className={classes.inputTextStyle2}
            disableUnderline={true}
            style={{ backgroundColor: 'rgb(220, 220, 220)' }}
          />
        </Grid>
        <Grid item xs={6} lg={6} md={6}>
          <Input
            placeholder={intl.formatMessage({
              id: 'id_memo.email',
            })}
            value={email}
            className={classes.inputTextStyle2}
            disableUnderline={true}
            style={{ backgroundColor: 'rgb(220, 220, 220)' }}
          />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
};
export default ComplementInputs;
